import { Base } from "@models/base";

export class TokenCheckResponse extends Base {
  ok: boolean;
  error: string;
}
